import React, { useState } from 'react';
import { MegaphoneIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import CustomBlackButton from '../sharedComponents/customBlackButton';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MoreDetailsPopup from '../ordersForBuyForMe/MoreDetailsPopup';
import ConsentDataTransferContainer from '../PackagingShipment/ConsentDataTransferContainer';

const ImportantAdver = () => {
  const { t } = useTranslation();
  const[isOpen,setISOpen]=useState(false)
  const handleClick = () => {
    // Open the path in a new tab
    setISOpen(true)
    // window.open('/ConsentDataTransfer', '_blank');
  };
  const onClose =()=>{
    setISOpen(false)
  }
  
  return (
    <div className="flex flex-col items-center justify-center p-10 my-10 bg-white">
      {/* Header Section */}
      <div className="flex items-center space-x-2">
        <MegaphoneIcon className="w-3 h-3 text-black md:w-6 md:h-6" />
        <h2 className="text-lg font-normal text-black md:text-3xl">
          {t("ImportantAnnouncement")}
                    </h2>
      </div>

      {/* Message Section */}
      <p className="mt-4 text-xs text-center text-gray-900 md:text-lg">
{t("Message")}
      </p>

      {/* Button Section */}
      <div className="mt-6">
        <CustomBlackButton children={t("MoreDetails")} icon={CreditCardIcon} 
          onClick={handleClick}
        />
      </div>
      {isOpen && (
        // <MoreDetailsPopup />
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-20">
          <div className="relative w-11/12 text-black bg-white rounded-md shadow-lg lg:w-6/12 md:w-9/12">
          <div className="flex justify-between p-3 text-black bg-gray-200 rounded-t-md">
            <h2 className="text-lg font-bold text-black">{t("consentDataTransferTitle")}</h2>
            <button
              className="text-black duration-300 top-2 right-2 hover:text-red-500"
              onClick={onClose}
            >
              ✕
            </button>
          </div>
            <ConsentDataTransferContainer />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImportantAdver;
